<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">备件入库</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建入库</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        clearable
        v-model="searchData.Code"
        placeholder="请输入入库单号"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        style="width: 300px; margin-left: 10px"
        v-model="searchData.InStorTime"
        value-format="yyyy-MM-dd"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <SelectData
        v-model="searchData.Status"
        :locationOptions="[
          { label: '待审核', Id: '0' },
          { label: '已审核', Id: '1' },
        ]"
        placeholder="请选择单据状态"
        style="width: 230px; margin-left: 10px"
      ></SelectData>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column
          label=""
          width="50"
          type="selection"
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column label="入库单号" align="center" prop="Code" sortable>
        </el-table-column>

        <el-table-column
          label="入库数量"
          align="center"
          prop="TotalNum"
          sortable
        >
        </el-table-column>

        <el-table-column
          label="入库时间"
          align="center"
          prop="InStorTime"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.InStorTime
                ? moment(scope.row.InStorTime).format('YYYY-MM-DD ')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="SupName" sortable>
        </el-table-column>
        <el-table-column
          label="制单人"
          align="center"
          prop="CreatorName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="审核人"
          align="center"
          prop="AuditUserName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="审核时间"
          align="center"
          prop="AuditeTime"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.AuditeTime
                ? moment(scope.row.AuditeTime).format('YYYY-MM-DD ')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="Status" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status === 0">待审核</el-tag>
            <el-tag type="success" v-if="scope.row.Status === 1">
              已审核</el-tag
            >
          </template>
        </el-table-column>

        <!-- <el-table-column label="货区类型" align="center" prop="Type">
          <template slot-scope="scope">
            <SelectDicName :typeValue="scope.row.Type" code="StorAreaType" />
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleEdit(scope.row, 1)"
              v-if="scope.row.Status === 1"
              >详情</el-button
            >
            <el-button
              type="text"
              @click="handleEdit(scope.row, 2)"
              v-if="scope.row.Status === 0"
              >审核</el-button
            >
            <el-button
              type="text"
              @click="handleEdit(scope.row)"
              v-if="scope.row.Status === 0"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              v-if="scope.row.Status === 0"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
import SelectData from '@/components/SelectData/SelectData'
export default {
  data() {
    return {
      moment,
      searchData: {
        Code: '',
        InStorTime: [],
        Status: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, SelectData },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.$set(this.searchData, 'InStorTime', [firstDay, lastDay])
      }
    },
    selectable(row, index) {
      return row.Status == 0
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/TD/TD_InStorage/GetInStorageList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'MaterialType',
              Keyword: this.FittingsTreeSearch || '',
            },
            {
              Condition: 'Code',
              Keyword: this.searchData.Code,
            },
            {
              Condition: 'InStorTime',
              Keyword:
                this.searchData.InStorTime?.length > 0
                  ? this.searchData.InStorTime.join(',')
                  : '',
            },
            {
              Condition: 'Status',
              Keyword: this.searchData.Status,
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建入库')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该入库单, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/TD/TD_InStorage/DeleteInStorageData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row, num) {
      if (num == 1) {
        this.$refs.EditForm.openForm('入库详情', row, true)
        return
      }
      if (num == 2) {
        this.$refs.EditForm.openForm('审核入库详情', row, true)
        return
      }
      this.$refs.EditForm.openForm('编辑入库', row, false)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['FittingsTreeSearch']),
  },
  watch: {
    FittingsTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
